import { Aktivitaet, AktivitaetTyp } from './types';

export const AKTIVITAET_TYP_LABEL: Record<AktivitaetTyp, string> = {
  email: 'Mail', ticket: 'Ticket', rechnung: 'Rechnung', dokument: 'Dokument', termin: 'Termin', notiz: 'Notiz',
  anruf: 'Anruf', meeting: 'Meeting', aenderung: 'Änderung',
};

// Filter-Chips (feste Reihenfolge), 'alle' zuerst.
export const AKTIVITAET_FILTER: { key: string; label: string }[] = [
  { key: 'alle', label: 'Alle' },
  { key: 'email', label: 'Mails' },
  { key: 'anruf', label: 'Anrufe' },
  { key: 'meeting', label: 'Meetings' },
  { key: 'ticket', label: 'Tickets' },
  { key: 'rechnung', label: 'Rechnungen' },
  { key: 'termin', label: 'Termine' },
  { key: 'dokument', label: 'Dokumente' },
  { key: 'notiz', label: 'Notizen' },
  { key: 'aenderung', label: 'Änderungen' },
];

// Lokaler Kalendertag (YYYY-MM-DD) aus einem Datums-String; '' bei ungültig.
function tagSchluessel(datum: string): string {
  const d = new Date(datum);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// "Heute" / "Gestern" / "Mi., 22. Juli 2026" relativ zu `heute`.
export function tagLabel(datum: string, heute: Date): string {
  const key = tagSchluessel(datum);
  if (!key) return 'Unbekannt';
  const alsKey = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const gestern = new Date(heute); gestern.setDate(gestern.getDate() - 1);
  if (key === alsKey(heute)) return 'Heute';
  if (key === alsKey(gestern)) return 'Gestern';
  return new Date(datum).toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: 'long', year: 'numeric' });
}

export interface TagesGruppe { key: string; label: string; items: Aktivitaet[]; }

// Nach Kalendertag gruppieren; Gruppen + Items absteigend (neueste zuerst).
export function gruppiereNachTag(akt: Aktivitaet[], heute: Date): TagesGruppe[] {
  const map = new Map<string, Aktivitaet[]>();
  for (const a of akt) {
    const key = tagSchluessel(a.datum);
    if (!map.has(key)) map.set(key, []);
    map.get(key)!.push(a);
  }
  const gruppen: TagesGruppe[] = [];
  for (const [key, items] of map) {
    items.sort((x, y) => (y.datum || '').localeCompare(x.datum || ''));
    gruppen.push({ key, label: items[0] ? tagLabel(items[0].datum, heute) : key, items });
  }
  gruppen.sort((a, b) => b.key.localeCompare(a.key));
  return gruppen;
}

// Nach Typ ('alle' = alle) + Freitextsuche (Titel/Detail) filtern.
export function filterAktivitaeten(akt: Aktivitaet[], typ: string, suche: string): Aktivitaet[] {
  const s = suche.trim().toLowerCase();
  return akt.filter((a) => {
    if (typ !== 'alle' && a.typ !== typ) return false;
    if (!s) return true;
    return (a.titel || '').toLowerCase().includes(s) || (a.detail || '').toLowerCase().includes(s);
  });
}
